import getStyleQuery from '../../../utils/tools/getStyleQuery';

// ----------------------------------------------------------------------

export function appBar() {
    return {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    [getStyleQuery()]: {
                        boxShadow: 'none',
                    },
                },
            },
        },
    };
}
